import { trim } from './strings';

export const isValidEmail = (email) => {
  const patt =
    // eslint-disable-next-line
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return patt.test(email);
};

// TODO: Improve the logic here.
export const isValidPhoneNumber = (phone) => {
  if (!phone) return false;

  // eslint-disable-next-line
  const patt = /^(\+?\d{1,3})?\s?(\d\s?){8,40}$/;
  return patt.test(trim(phone));
};

export const isValidPersonNumber = (personNumber) => {
  if (personNumber) {
    const patt =
      /^(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])\d{7}$/;
    const pattSpaced =
      /^(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])(\d{2})( )(\d{5})$/;
    return patt.test(trim(personNumber)) || pattSpaced.test(trim(personNumber));
  }
  return false;
};
